import React from 'react';
import Reflux from 'reflux';
import { Version } from '@shoflo-rundown/polymer.legacy';
import VersionNumberStore from 'shared/flux/stores/VersionNumberStore';
export default React.createClass({
  displayName: 'Footer',

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connectFilter(VersionNumberStore, 'display', (state) =>
      state.get('display'),
    ),
  ],

  getDefaultProps() {
    return {
      packageVersion: null,
    };
  },

  render() {
    const { display } = this.state;

    return (
      <footer>
        <div>
          {display && <Version packageVersion={this.props.packageVersion} />}
        </div>
      </footer>
    );
  },
});
